// resources/js/admin/components/shared/locales/LocaleRow.tsx

import { Locale } from "../../../types/features/Locale";
import TableRow from "../../ui/TableRow";

interface LocaleRowProps {
    locale: Locale;
    onAction: (locale: Locale) => void;
    onSelect?: (locale: Locale, isSelected: boolean) => void;
    isSelected?: boolean;
    selectable?: boolean;
}

export default function LocaleRow({
    locale,
    onAction,
    onSelect,
    isSelected = false,
    selectable = false,
}: LocaleRowProps) {
    const getStatusBadge = () => {
        return locale.is_active
            ? { label: "Actif", className: "bg-green-100 text-green-700" }
            : { label: "Inactif", className: "bg-gray-100 text-gray-500" };
    };

    const statusBadge = getStatusBadge();

    return (
        <TableRow
            item={locale}
            onAction={onAction}
            onSelect={onSelect}
            isSelected={isSelected}
            selectable={selectable}
            actionable={true}
        >
            <td className="py-3 px-4">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-xl">
                        {locale.flag || "🌐"}
                    </div>
                    <div>
                        <span className="font-medium text-gray-800 block">{locale.name}</span>
                        <span className="text-xs text-gray-500">{locale.code.toUpperCase()}</span>
                    </div>
                </div>
            </td>

            <td className="py-3 px-4">
                <span className="text-gray-600 text-sm">{locale.code.toUpperCase()}</span>
            </td>

            <td className="hidden sm:table-cell py-3 px-4">
                {locale.is_rtl ? (
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-700">
                        RTL
                    </span>
                ) : (
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-500">
                        LTR
                    </span>
                )}
            </td>

            <td className="hidden md:table-cell py-3 px-4">
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusBadge.className}`}>
                    {statusBadge.label}
                </span>
            </td>

            <td className="hidden lg:table-cell py-3 px-4">
                <span className="text-gray-500 text-sm">
                    {locale.fallback ? locale.fallback.toUpperCase() : "-"}
                </span>
            </td>

            <td className="hidden xl:table-cell py-3 px-4">
                <span className="text-gray-500 text-sm">
                    {new Date(locale.created_at).toLocaleDateString("fr-FR")}
                </span>
            </td>
        </TableRow>
    );
}